module.exports = __webpack_public_path__ + "static/media/logo_ebdm34_el.f7b03dd2.jpg";